import React from 'react';
import Flex from '../../../Flex';
import FavouriteStat from '../FavouriteStat';
import GroupStat from '../GroupStat';
import CommentStat from '../CommentStat';
import ShareStat from '../ShareStat';
import { useDeviationAttributes } from '../hooks/useDeviationAttributes';
export var SecondaryActionBarIcons = function (_a) {
    var className = _a.className, isOwner = _a.isOwner, deviation = _a.deviation;
    var _b = useDeviationAttributes(deviation, isOwner), isCommentable = _b.isCommentable, isFavouritable = _b.isFavouritable, isGroupSubmittable = _b.isGroupSubmittable, isShareable = _b.isShareable;
    return (React.createElement(Flex, { justifyContent: "space-between", className: className },
        React.createElement(Flex, { justifyContent: "flex-start", alignItems: "center" },
            isCommentable && React.createElement(CommentStat, { deviation: deviation }),
            isFavouritable && (React.createElement(FavouriteStat, { isOwner: isOwner, deviation: deviation, actionBarType: "secondary" })),
            isGroupSubmittable && (React.createElement(GroupStat, { deviation: deviation, actionBarType: "secondary" })),
            isShareable && React.createElement(ShareStat, { deviation: deviation }))));
};
SecondaryActionBarIcons.displayName = 'SecondaryActionBarIcons';
export default SecondaryActionBarIcons;
//# sourceMappingURL=SecondaryActionBarIcons.js.map